import { WEBHOOK_EVENT } from '@dashboard/enums/webhook-events';

// Formik reads a dot in a field name as a nested path.
export const eventFieldName = event => `event_${event.replaceAll('.', '_')}`;

export const selectedWebhookEvents = values =>
  Object.values(WEBHOOK_EVENT).filter(event => values[eventFieldName(event)]);
